module.exports = __webpack_public_path__ + "img/wunderlich.b5336730.jpeg";